import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-registration-stepper',
  templateUrl: './registration-stepper.component.html',
  styleUrl: './registration-stepper.component.scss'
})
export class RegistrationStepperComponent {
  @Input() currentStep: number = 1;
}
